import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface DownloadProvidedDocumentProps {
  declarationId: string;
  fileName: string;
}

export const useDownloadProvidedDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, fileName }: DownloadProvidedDocumentProps) => {
      const { data, headers } = await request(
        {
          path: `declarations/${declarationId}/provided-documents/download/${fileName}`,
          method: 'GET',
          authenticate: true,
          fileDownload: true,
        },
        true,
      );

      const href = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      const filename = headers['content-disposition']?.match(/filename="([^"]*)"/)?.[1] || fileName;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return { data, headers };
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading document!');
    },
  });
};
